module.exports = __webpack_public_path__ + "static/media/home-hero--bg-utah.773fcdd0.jpg";